import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Menu.css'; // Import the CSS file

const Menu = ({ isOpen, toggleMenu, categories = [], selectedLang, onLanguageChange }) => {
  useEffect(() => {
    if (window.innerWidth >= 768) {
      toggleMenu(true); // Set menu open by default on desktop devices
    }
  }, []);

  const isDesktop = window.innerWidth >= 768;

  return (
    <div className={`menu ${isOpen || isDesktop ? 'open' : ''} ${isDesktop ? 'desktop' : 'mobile'}`}>
      {!isDesktop && (
        <div className="close-icon" onClick={toggleMenu}>&times;</div> /* Keep the close icon for mobile */
      )}
      <ul>
        <li><Link to="/" onClick={toggleMenu}>صفحة البداية</Link></li>
        {categories.map((category) => (
          <li key={category.ID}>
            <Link to={`/section/${category.ID}`} onClick={toggleMenu}>{category.Name}</Link>
          </li>
        ))}
      </ul>
      <div className="language-switcher">
        <button 
          className={selectedLang === 'ar' ? 'active' : ''} 
          onClick={() => onLanguageChange('ar')}
        >
          عربي
        </button>
        <button 
          className={selectedLang === 'he' ? 'active' : ''} 
          onClick={() => onLanguageChange('he')}
        >
          עברית
        </button>
      </div>
    </div>
  );
};

export default Menu;
